import React from "react";
import http from "services/httpService";
import TpaSetup from "components/Tpa";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import routes from "components/routes";

const TPASetup = () => {
  const userplan_id = localStorage.getItem("eb_current_plan");
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleSubmit = async (values) => {
    await updateTpaDetails(values);
  };

  const updateTpaDetails = async (values) => {
    const payload = {
      userplan_id,
      ...values,
    };
    try {
      const { data } = await http.post(
        `/business/update_tpa_details/`,
        payload
      );
      try {
        const selectedValues = JSON.parse(
          localStorage.getItem("eb_selected_values") || "{}"
        );
        if (selectedValues?.userplans_data?.[userplan_id]) {
          selectedValues.userplans_data[userplan_id].userplan_tpa_data = {
            ...(selectedValues.userplans_data[userplan_id].userplan_tpa_data ||
              {}),
            tpa_id: values.tpa_id,
            tpa_userplan_unique_code: values.tpa_userplan_unique_code || "",
            cashless_details: values.cashless.flat(),
            escalation_details: values.escalation_details.flat(),
          };
          localStorage.setItem(
            "eb_selected_values",
            JSON.stringify(selectedValues)
          );
        }
      } catch (storageError) {
        console.log(storageError);
      }
      if (location.state?.returnTo) {
        navigate(location.state.returnTo, { replace: true });
        return;
      }
      navigate(`/${routes.UNIVERSAL_COVERAGE_DOC}`)
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <section>
      <TpaSetup handleSubmit={handleSubmit} />
    </section>
  );
};

export default TPASetup;
